<template>
  <figure class="media">
    <div class="fistMediaView" style="width: 100%; height: 100%;">
      <span
        class="prevArrow"
        :style="prevArrowStyle"
        @click="prevSlide()"
      ></span>
      <img
        v-if="selectedSlide.type === 'Image'"
        width="80%"
        height="80%"
        :src="selectedSlide.url"
      />
      <iframe
        v-else
        width="85%"
        height="80%"
        :src="selectedSlide.url"
        frameborder="0"
      ></iframe>
      <span
        class="nextArrow"
        :style="nextArrowStyle"
        @click="nextSlide()"
      ></span>
    </div>

    <div class="selectArea">
      <div v-for="(slide, index) in slides.slice(prev, next)" :key="index">
        <figcaption
          v-if="slide.type === 'Video'"
          @click="selectSlide(prev + index)"
          :class="{ selectedBorder: selectedBorder(prev + index) }"
        >
          <img :src="slide.image" />
        </figcaption>
        <figcaption
          v-else-if="slide.type === 'Image'"
          @click="selectSlide(prev + index)"
          :class="{ selectedBorder: selectedBorder(prev + index) }"
        >
          <img :src="slide.url" />
        </figcaption>
      </div>
    </div>
  </figure>
</template>

<script>
export default {
  name: "media",
  props: {
    slides: Array,
  },
  data() {
    return {
      selectedSlide: this.slides[0],
      slideLength: this.slides.length,
      prev: 0,
      next: 5,
      activeArrow: { opacity: "1.0", cursor: "pointer" },
      inActiveArrow: { opacity: "0.2", cursor: "default" },
      selectedSlideIndex: 0,
    };
  },
  computed: {
    slideType() {
      return this.selectedSlide.type === "Image"
        ? "image-slide"
        : "video-slide";
    },
    prevArrowStyle() {
      return this.selectedSlideIndex !== 0
        ? this.activeArrow
        : this.inActiveArrow;
    },
    nextArrowStyle() {
      if (this.slides.length == 0) {
        return this.inActiveArrow;
      } else {
        return this.selectedSlideIndex + 1 !== this.slideLength &&
          this.slides[this.selectedSlideIndex + 1].type !== "Blank"
          ? this.activeArrow
          : this.inActiveArrow;
      }
    },
  },
  methods: {
    selectSlide(index) {
      this.selectedSlideIndex = index;
      this.selectedSlide = this.slides[index];
    },
    prevSlide() {
      if (this.selectedSlideIndex !== 0) {
        if ((this.selectedSlideIndex - 1) % 5 === 0 && this.prev > 0) {
          this.prev -= 1;
          this.next -= 1;
        }
        this.selectedSlideIndex -= 1;
        this.selectSlide(this.selectedSlideIndex);
        this.selectedBorder(this.selectedSlideIndex);
      }
    },
    nextSlide() {
      if (
        this.selectedSlideIndex + 1 < this.slideLength &&
        this.blankSlide(this.selectedSlideIndex)
      ) {
        if ((this.selectedSlideIndex + 1) % 5 === 0 && this.prev === 0) {
          this.prev += 1;
          this.next += 1;
        }
        this.selectedSlideIndex += 1;
      }
      this.selectSlide(this.selectedSlideIndex);
      this.selectedBorder(this.selectedSlideIndex);
    },
    blankSlide(index) {
      this.selectedSlide = this.slides[index + 1];
      return this.selectedSlide.type !== "Blank";
    },
    selectedBorder(index) {
      return this.slides[index] === this.selectedSlide;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/hpCustom.scss";
@import "../../styles/hpConstant.scss";

.media {
  @include hpFlex(column);
  margin: 0 1%;

  .fistMediaView {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    @mixin arrow($borderWidth) {
      width: 17px;
      height: 17px;
      border: solid $hpDeepGray;
      border-width: $borderWidth;
      transform: rotate(135deg);
      cursor: pointer;
    }

    .prevArrow {
      @include arrow(0 3px 3px 0);
    }

    .nextArrow {
      @include arrow(3px 0 0 3px);
    }
  }

  .mediaArea figcaption img:hover,
  .mediaArea figcaption embed:hover {
    opacity: 1;
    cursor: pointer;
  }

  .selectArea {
    width: 85%;
    height: 50%;
    margin-right: 3%;

    figcaption {
      display: inline-block;
      vertical-align: top;
      width: 19.8%;
      float: left;

      img,
      embed {
        height: 62px;
        width: 90px;
        display: block;
        cursor: pointer;
      }
    }
   
  }

  .selectedBorder {
    box-shadow: 0 0 0 2px $hpPrimary inset;
  }
}
@media only screen and (min-width: 576px) {
  .prevArrow {
    margin-right: 15px;
  }
  .nextArrow {
    margin-left: 15px;
  }
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
img{
  width:100%;
  height: 100%;
 
}

}
</style>
